import { ArrowRight } from "lucide-react";
import axcelLogo from "@/assets/logos/axcel.webp";
import handelsbankenLogo from "@/assets/logos/handelsbanken.webp";
import danskebankLogo from "@/assets/logos/danskebank.webp";
import abgLogo from "@/assets/logos/abg.webp";
import dnbCarnegieLogo from "@/assets/logos/dnb-carnegie.webp";
import paretoLogo from "@/assets/logos/pareto-securities.webp";

const opportunities = [
  { company: "Axcel", logo: axcelLogo, href: "https://axcel.teamtailor.com/jobs" },
  { company: "Handelsbanken", logo: handelsbankenLogo, href: "https://emp.jobylon.com/companies/2204-svenska-handelsbanken-ab/" },
  { company: "Danske Bank", logo: danskebankLogo, href: "https://ejqi.fa.ocs.oraclecloud.eu/hcmUI/CandidateExperience/en/sites/CX_1001/jobs?location=Sweden&locationId=300000000296318&locationLevel=country&mode=location" },
  { company: "ABG Sundal Collier", logo: abgLogo, href: "https://www.abgsc.com/careers/#component-4" },
  { company: "DNB Carnegie", logo: dnbCarnegieLogo, href: "https://jobs.carnegie.se/search/?createNewAlert=false&q=&locationsearch=" },
  { company: "Pareto Securities", logo: paretoLogo, href: "https://paretosec.com/updates/vacant-positions/" },
];

const OpportunitiesSection = () => {
  return (
    <section
      className="py-24 md:py-32 bg-paper text-navy-dark"
      aria-labelledby="opportunities-heading"
    >
      <div className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <span className="text-steel uppercase tracking-[0.3em] text-[10px] font-bold mb-4 block">
              Career Openings
            </span>
            <h2
              id="opportunities-heading"
              className="font-serif text-4xl lg:text-5xl text-navy-dark"
            >
              Opportunities
            </h2>
          </div>
          <p className="text-navy/60 uppercase tracking-[0.2em] text-[10px] font-bold max-w-sm">
            Job &amp; Internship Listings
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-navy-dark/10 border border-navy-dark/10">
          {opportunities.map((opp) => (
            <a
              key={opp.company}
              href={opp.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-paper aspect-[4/3] flex items-center justify-center overflow-hidden transition-colors hover:bg-navy-dark"
            >
              <img
                src={opp.logo}
                alt={`${opp.company} logo`}
                className="max-h-14 object-contain opacity-70 transition-all duration-300 group-hover:opacity-0"
              />
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-6 opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-paper">
                <h3 className="font-serif text-xl text-center">{opp.company}</h3>
                <span className="inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.25em] border-b border-steel-light pb-1">
                  View Roles
                  <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OpportunitiesSection;
